export const calculateZoom = (constituencies) => {
    if (!constituencies || !constituencies.features) return constituencies;
    constituencies.features.forEach(constituency => {
        if (!constituency || !constituency.geometry) return;

        let minLng, minLat, maxLng, maxLat;
        const coords = (constituency.geometry.type === "Polygon")
            ? [constituency.geometry.coordinates[0]]
            : (constituency.geometry.type === "MultiPolygon" ? constituency.geometry.coordinates.map(p => p[0]) : []);

        if (!coords || coords.length === 0) return;

        coords.forEach(ring => {
            ring.forEach(coord => {
                if (!minLng || minLng > coord[0]) minLng = coord[0];
                if (!minLat || minLat > coord[1]) minLat = coord[1];
                if (!maxLng || maxLng < coord[0]) maxLng = coord[0];
                if (!maxLat || maxLat < coord[1]) maxLat = coord[1];
            });
        });

        constituency.properties.minLng = minLng;
        constituency.properties.minLat = minLat;
        constituency.properties.maxLng = maxLng;
        constituency.properties.maxLat = maxLat;
        constituency.properties.LONG = (minLng + maxLng) / 2;
        constituency.properties.LAT = (minLat + maxLat) / 2;
    });
    return constituencies;
};
